import { render, staticRenderFns } from "./carPerk.vue?vue&type=template&id=9d55279e&scoped=true"
import script from "./carPerk.vue?vue&type=script&lang=js"
export * from "./carPerk.vue?vue&type=script&lang=js"
import style0 from "./carPerk.vue?vue&type=style&index=0&id=9d55279e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d55279e",
  null
  
)

export default component.exports